import React from "react";
import ServicePage from "../components/ServicePage";
import { STORAGE } from "../lib/assets";

const cfg = {
  slug: "storage",
  testid: "storage-page",
  breadcrumb: "Storage",
  serviceName: "Home Storage Units",
  seoTitle: "Home Storage Units in Noida & Delhi NCR | DIDIT",
  seoDesc:
    "Custom home storage by DIDIT for modern Indian homes in Noida and Delhi NCR — crockery units, media units and foyer storage designed to fit your space, with transparent costing and a 10-year warranty on modulars.",
  canonical: "https://didithomes.com/storage",
  overline: "Storage",
  h1: "Storage Designed Around Your Home",
  heroSub:
    "Considered storage that disappears into the architecture — from crockery and media units to foyer cabinets, planned to keep everyday life tidy.",
  secondaryCta: "Explore Storage Options",
  heroImg: STORAGE.hero,
  heroAlt: "Tall crockery and pantry storage unit by DIDIT in a warm modern Indian home",
  introOverline: "The DIDIT approach",
  introH2: "A place for everything, built in",
  introP:
    "We design storage around your rooms, your belongings and how you move through your home each day — so units feel integrated rather than added on, and everything you use often stays within easy reach.",
  introImg: STORAGE.media,
  introAlt: "Living room media and storage unit with open shelving and closed cabinets",
  chips: ["Available space", "What you store", "Daily flow", "Access", "Finish", "Budget"],
  optionsOverline: "Storage options",
  optionsH2: "Storage for every part of your home",
  optionsSub:
    "From the kitchen and dining area to the living room and entryway, we plan storage that fits the room and the way you use it.",
  options: [
    { name: "Crockery & Pantry Units", img: STORAGE.crockery, alt: "Crockery unit with glass-front display cabinets and drawers", copy: "Tall and low units with a mix of display and closed storage — keeping dishware, glassware and pantry essentials organised and easy to reach." },
    { name: "Media & Living Units", img: STORAGE.media, alt: "Living room TV and media unit with shelving and cabinets", copy: "TV and media units that combine open shelving with concealed storage, keeping the living room tidy while showcasing what you love." },
    { name: "Foyer & Utility Storage", img: STORAGE.foyer, alt: "Foyer storage unit with shoe cabinet, bench and mirror", copy: "Entryway and utility storage — shoe cabinets, benches and slim drawers that make daily comings and goings effortless." },
  ],
  ctaH2: "Let's design your storage",
  ctaSub:
    "Tell us about your rooms and what you need to keep close at hand. We'll plan storage designed around the way you live.",
};

export default function Storage() {
  return <ServicePage cfg={cfg} />;
}
